/**
 * module name - kyc
 * 用户kyc信息
 */

export default {
  namespaced: true,
  state: {
    // check接口返回的kycx信息
    userKycInfoCheck: {},
    jumpPathAfterKyc: {},
  },
  mutations: {
    set_userKycInfoCheck(state, data) {
      state.userKycInfoCheck = data;
    },
    set_jumpPathAfterKyc(state, data) {
      state.jumpPathAfterKyc = data;
    },
  },
};
